// Checks if REACT_APP_NODE_ENV is equal to production
export const isProduction = process.env.REACT_APP_NODE_ENV === "production";
